import type { ReactNode } from "react";

export default function Maintenance() {
  return (
    <main className="min-h-screen flex items-start justify-center bg-neutral-background px-6 pt-16 pb-12 md:pt-24">
      <div className="w-full max-w-5xl text-center">
        <img
          src="/maintenance-illustration.svg"
          alt="Engineer building improvements alongside a robot"
          className="mx-auto mb-10 w-full max-w-3xl h-auto"
        />

        <h1 className="font-serif text-5xl font-semibold text-base-500 mb-6">
          We're hard at work.
        </h1>
        <p className="font-sans text-lg text-neutral-600 mb-2">
          Launch10 is down for a quick bit of maintenance.
        </p>
        <p className="font-sans text-lg text-neutral-600">
          We'll be back shortly — thanks for your patience.
        </p>
      </div>
    </main>
  );
}

// Render full-screen — opt out of the default SiteLayout (sidebar + header)
// that would otherwise constrain the image and add chrome we don't want here.
Maintenance.layout = (page: ReactNode) => page;
